import { SyntheticEvent, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setDuration } from 'store/invoices/invoices.slice'
import TwoColumnLayout from '../../layouts/two-column-layout/two-column-layout'
import InvoiceDetails from './invoice-details/invoice-details'
import InvoiceMobile from './invoice-mobile/invoice-mobile'
import InvoiceSelection from './invoice-selection/invoice-selection'
import {
  InvoiceWorkspaceProvider,
  InvoiceCustomerScope,
} from './invoice-workspace.context'
import { useGetUserCompanyAssociationByUserQuery } from 'store/company/company.api'
import { getUserId } from 'utils/common'
// import InvoiceProvider from './invoice.provider'

const InvoicePage = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const userId = getUserId()
  const {
    data: userCompanyAssociations,
    isSuccess: associationsLoaded,
    isError: associationsError,
  } = useGetUserCompanyAssociationByUserQuery({ userId }, { skip: !userId })
  const hasAnyFactoringCompany = Boolean(
    userCompanyAssociations?.some((a) => a.factoringEnabled)
  )
  const isFactoringPath = pathname.startsWith('/factoring')

  useEffect(() => {
    if (!isFactoringPath || !userId) return
    if (associationsError) {
      navigate('/invoice', { replace: true })
      return
    }
    if (!associationsLoaded) return
    if (!hasAnyFactoringCompany) {
      navigate('/invoice', { replace: true })
    }
  }, [
    isFactoringPath,
    userId,
    associationsLoaded,
    hasAnyFactoringCompany,
    associationsError,
    navigate,
  ])

  const customerScope: InvoiceCustomerScope = pathname.startsWith('/factoring')
    ? 'factoring'
    : 'standard'
  const [tabsValue, setTabsValue] = useState(0)

  const handleChange = (_event: SyntheticEvent, newValue: number) => {
    setTabsValue(newValue)
    dispatch(setDuration('All'))
  }

  useEffect(() => {
    dispatch(setDuration('All'))
  }, [pathname, dispatch])

  useEffect(() => {
    return () => {
      dispatch(setDuration('All'))
    }
  }, [dispatch])

  return (
    <InvoiceWorkspaceProvider value={customerScope}>
      <TwoColumnLayout>
        <InvoiceSelection tabsValue={tabsValue} handleChange={handleChange} />
        <InvoiceDetails tabsValue={tabsValue} />
        <InvoiceMobile tabsValue={tabsValue} handleChange={handleChange} />
      </TwoColumnLayout>
    </InvoiceWorkspaceProvider>
  )
}

export default InvoicePage
